import { gql } from 'urql';

export const PerformCheckDeposit = gql`
  mutation PerformCheckDeposit(
    $idempotencyId: IdempotencyToken!
    $input: SubmitRdcInput!
  ) {
    submitRdc(idempotencyId: $idempotencyId, input: $input) {
      ... on SubmitRdcSuccess {
        __typename
        id
        fundsAvailability
      }
      ... on SubmitRdcValidationError {
        __typename
        id
        fundsAvailability
        code
        title
        message
        errors {
          description
          severity
          isFixable
          isConfirmable
          fields
        }
      }
      ... on SubmitRdcError {
        __typename
        code
        title
        message
      }
    }
  }
`;

export default PerformCheckDeposit;
